<template>
  <material-card
    :title="title"
    color="dover-blue">
    <v-form
      ref="form"
      v-model="isValidationOk"
      lazy-validation>
      <v-container
        py-0>
        <v-layout
          wrap>
          <v-flex
            xs12
            md12
            lg12>
            <v-data-table
              v-if="mainSettings.posProtocols"
              :headers="headers"
              :items="mainSettings.posProtocols"
              :no-data-text="`${ Maglink.NoDataMessage(false) }`"
              :no-results-text="`${ Maglink.NoDataMessage(true) }`"
              hide-actions>
              <template
                slot="headerCell"
                slot-scope="{ header }">
                <span
                  class="dover-light-blue-color"
                  v-text="header.text"/>
              </template>
              <template
                slot="items"
                slot-scope="{ item }"
                class="dover-light-blue-color">
                <td
                  class="text-xs-center"
                  width="3%">
                  {{ item.pos }}
                </td>
                <td
                  class="text-xs-center"
                  width="12%">
                  <v-btn-toggle
                    v-model.number="item.type"
                    mandatory
                    @change="onTypeChange(item)">
                    <v-btn
                      :key="2"
                      :value="2"
                      text
                      small
                      color="dover-blue">
                      {{ $t('None') }}
                    </v-btn>
                    <v-btn
                      :key="0"
                      :value="0"
                      text
                      small
                      color="dover-blue">
                      {{ $t('Serial') }}
                    </v-btn>
                    <v-btn
                      :key="1"
                      :value="1"
                      text
                      small
                      color="dover-blue">
                      {{ $t('Tcp-Ip').toUpperCase() }}
                    </v-btn>
                  </v-btn-toggle>
                </td>
                <td
                  class="text-xs-center"
                  width="5%">
                  <v-btn-toggle
                    v-model="item.acr">
                    <v-btn
                      v-if="!isNonePos(item.type) && isFirstPos(item)"
                      :key="1"
                      :value="1"
                      text
                      small
                      color="dover-blue"
                      @change="onSalesChange(item)">
                      {{ item.acr ? $t('Yes') : $t('No') }}
                    </v-btn>
                  </v-btn-toggle>
                </td>
                <td
                  class="text-xs-left"
                  width="10%">
                  <v-select
                    v-if="!isNonePos(item.type)"
                    v-model.number="item.protocol"
                    :items="protocols"
                    :label="`${ $t('Protocol') }`"
                    item-text="desc"
                    item-value="code"
                    class="dover-input" />
                </td>
                <td
                  class="text-xs-left"
                  width="5%">
                  <v-btn
                    v-if="isGilbarcoPos(item.protocol)"
                    small
                    class="mx-0 my-0"
                    dark
                    fab
                    color="dover-blue"
                    @click="showGVRDialog(true)">
                    <v-icon dark>
                      mdi-information
                    </v-icon>
                  </v-btn>
                </td>
                <td
                  class="text-xs-left"
                  width="7%">
                  <v-select
                    v-if="isGilbarcoPos(item.protocol)"
                    v-model.number="item.unitSet"
                    :disabled="isNonePos(item.type)"
                    :items="unitList"
                    :label="`${ $t('Units') }`"
                    item-text="desc"
                    item-value="code"
                    class="dover-input"/>
                </td>
                <td
                  class="text-xs-left"
                  width="7%">
                  <v-text-field
                    v-if="isSerialPos(item.type)"
                    v-model.trim="item.port"
                    :rules="serialPortValidation"
                    :counter="1"
                    :label="`${ $t('Port') }`"
                    class="dover-input"
                    @input="onCommPortChange(item)"/>
                  <v-text-field
                    v-if="isTcpIpPos(item.type)"
                    v-model.trim="item.port"
                    :rules="tcpIpPortValidation"
                    :counter="5"
                    :label="`${ $t('Port') }`"
                    class="dover-input"
                    @change="onTcpIpPortChange(item)"/>
                </td>
                <td
                  class="text-xs-left"
                  width="7%">
                  <v-select
                    v-if="isSerialPos(item.type)"
                    v-model="item.baudRate"
                    :disabled="isNonePos(item.type)"
                    :items="baudRateList"
                    :label="`${ $t('Baud rate') }`"
                    item-text="desc"
                    item-value="code"
                    class="dover-input"/>
                </td>
                <td
                  class="text-xs-left"
                  width="7%">
                  <v-select
                    v-if="isSerialPos(item.type)"
                    v-model="item.parity"
                    :disabled="isNonePos(item.type)"
                    :items="parityList"
                    :label="`${ $t('Parity') }`"
                    item-text="desc"
                    item-value="code"
                    class="dover-input"/>
                </td>
                <td
                  class="text-xs-left"
                  width="7%">
                  <v-select
                    v-if="isSerialPos(item.type)"
                    v-model="item.dataBit"
                    :disabled="isNonePos(item.type)"
                    :items="dataBitList"
                    :label="`${ $t('Data bit') }`"
                    item-text="desc"
                    item-value="code"
                    class="dover-input"/>
                </td>
                <td
                  class="text-xs-left"
                  width="7%">
                  <v-select
                    v-if="isSerialPos(item.type)"
                    v-model="item.stopBit"
                    :disabled="isNonePos(item.type)"
                    :items="stopBitList"
                    :label="`${ $t('Stop bit') }`"
                    item-text="desc"
                    item-value="code"
                    class="dover-input"/>
                </td>
              </template>
            </v-data-table>
          </v-flex>
          <v-flex
            xs6
            md3
            lg3>
            <span
              class="caption font-weight-light">
              {{ $t('Gilbarco invalid field character') }}
            </span>
            <hr>
            <v-btn-toggle
              v-model="gilbarcoInvalidField"
              mandatory>
              <v-btn
                :key="0"
                :value="0"
                text
                small
                color="dover-blue">
                {{ '?' }}
              </v-btn>
              <v-btn
                :key="1"
                :value="1"
                text
                small
                color="dover-blue">
                {{ '0' }}
              </v-btn>
            </v-btn-toggle>
          </v-flex>
          <v-flex
            xs12
            md12
            lg12>
            <span
              class="caption font-weight-light">
              {{ $t('Printer connection') }}
            </span>
            <hr>
            <v-btn-toggle
              v-model="mainSettings.printer"
              mandatory>
              <v-btn
                :key="9"
                :value="9"
                text
                small
                color="dover-blue">
                {{ $t('None') }}
              </v-btn>
              <v-btn
                :key="1"
                :value="1"
                :disabled="!commPort1Available"
                text
                small
                color="dover-blue">
                {{ $t('Comm {0}', [ '1' ]) }}
              </v-btn>
              <v-btn
                :key="2"
                :value="2"
                :disabled="!commPort2Available"
                text
                small
                color="dover-blue">
                {{ $t('Comm {0}', [ '2' ]) }}
              </v-btn>
              <v-btn
                :key="0"
                :value="0"
                text
                small
                color="dover-blue">
                {{ $t('USB') }}
              </v-btn>
            </v-btn-toggle>
          </v-flex>
          <v-dialog
            v-model="GVRdialog"
            persistent
            width="600px"
            @keydown.esc="GVRdialog = false">
            <v-card>
              <v-card-title
                class="headline grey lighten-2"
                primary-title>
                {{ $t('Gilbarco Veeder-Root serial interface messages') }}
              </v-card-title>
              <v-card-text>
                <div><v-chip>s00300</v-chip>{{ $t('Remote alarm reset') }}</div>
                <div><v-chip>s052xx</v-chip>{{ $t('Start leak detection') }}</div>
                <div><v-chip>s053xx</v-chip>{{ $t('Stop leak detection') }}</div>
                <div><v-chip>i101xx</v-chip><v-chip>I101xx</v-chip>{{ $t('System status report') }}</div>
                <div><v-chip>i111xx</v-chip><v-chip>I111xx</v-chip>{{ $t('Priority Alarm history report') }}</div>
                <div><v-chip>i11200</v-chip><v-chip>I11200</v-chip>{{ $t('Non priority alarm history report') }}</div>
                <div><v-chip>i113xx</v-chip><v-chip>I113xx</v-chip>{{ $t('Active alarm report') }}</div>
                <div><v-chip>i11400</v-chip><v-chip>I11400</v-chip>{{ $t('Cleared alarm report') }}</div>
                <div><v-chip>i201xx</v-chip><v-chip>I201xx</v-chip>{{ $t('In-tank inventory report') }}</div>
                <div><v-chip>i202xx</v-chip><v-chip>I202xx</v-chip>{{ $t('In-tank delivery report') }}</div>
                <div><v-chip>i203xx</v-chip>{{ $t('In-tank leak detection report') }}</div>
                <div><v-chip>i204xx</v-chip><v-chip>I204xx</v-chip>{{ $t('In-tank shift inventory report') }}</div>
                <div><v-chip>i205xx</v-chip><v-chip>I205xx</v-chip>{{ $t('In-tank status report') }}</div>
                <div><v-chip>i207xx</v-chip>{{ $t('In-tank Leak Test History Report') }}</div>
                <div><v-chip>i208xx</v-chip>{{ $t('In-tank Leak Test Results Report') }}</div>
                <div><v-chip>i209xx</v-chip>{{ $t('Enhanced In-tank Leak Detect Report') }}</div>
                <div><v-chip>i214xx</v-chip><v-chip>I214xx</v-chip>{{ $t('In-tank mass/density inventory report') }}</div>
                <div><v-chip>i231xx</v-chip>{{ $t('In-tank full inventory report') }}</div>
                <div><v-chip>i234xx</v-chip>{{ $t('In tank Mass/density inventory report') }}</div>
                <div><v-chip>i373qq</v-chip>{{ $t('Pressure Line Leak Test Results (with 0.2 gph test data)') }}</div>
                <div><v-chip>i374qq</v-chip>{{ $t('Pressure Line Leak Test History (with 0.2 gph test data)') }}</div>
                <div><v-chip>i383qq</v-chip>{{ $t('Pressure Line Leak Test Results (0.1 gph test data only)') }}</div>
                <div><v-chip>i384qq</v-chip>{{ $t('Pressure Line Leak Test History (0.1 gph test data only)') }}</div>
                <div><v-chip>i406xx</v-chip><v-chip>I406xx</v-chip>{{ $t('Relay status report') }}</div>
                <div><v-chip>s50100</v-chip>{{ $t('Set time of the day') }}</div>
                <div><v-chip>i50100</v-chip>{{ $t('Read time of the day') }}</div>
                <div><v-chip>i503ll</v-chip><v-chip>I503ll</v-chip>{{ $t('Print Header Line') }}</div>
                <div><v-chip>i601</v-chip><v-chip>I601</v-chip>{{ $t('Tank Configuration On/Off') }}</div>
                <div><v-chip>i602</v-chip><v-chip>I602</v-chip>{{ $t('Tank Product Label') }}</div>
                <div><v-chip>i61E</v-chip><v-chip>I61E</v-chip>{{ $t('Tank Density') }}</div>
                <div><v-chip>i621</v-chip><v-chip>I621</v-chip>{{ $t('Tank Low Level Limit') }}</div>
                <div><v-chip>i622</v-chip><v-chip>I622</v-chip>{{ $t('Tank High Level Limit') }}</div>
                <div><v-chip>i623</v-chip><v-chip>I623</v-chip>{{ $t('Tank Overfill Level Limit') }}</div>
                <div><v-chip>i624</v-chip><v-chip>I624</v-chip>{{ $t('Tank High Water Level Limit') }}</div>
                <div><v-chip>i627</v-chip><v-chip>I627</v-chip>{{ $t('Tank High Water Warning Limit') }}</div>
                <div><v-chip>i628</v-chip><v-chip>I628</v-chip>{{ $t('Tank Maximum Volume Limit') }}</div>
                <div><v-chip>i629</v-chip><v-chip>I629</v-chip>{{ $t('Tank Delivery Required Limit') }}</div>
                <div><v-chip>i640</v-chip>{{ $t('Tank Correction Table') }}</div>
                <div><v-chip>i645</v-chip>{{ $t('Tank product id') }}</div>
                <div><v-chip>i646</v-chip>{{ $t('Tank High High Level Limit') }}</div>
                <div><v-chip>i647</v-chip>{{ $t('Tank High Level Limit') }}</div>
                <div><v-chip>i648</v-chip>{{ $t('Tank Low Level Limit') }}</div>
                <div><v-chip>i649</v-chip>{{ $t('Tank Low Low Level Limit') }}</div>
                <div><v-chip>i785qq</v-chip><v-chip>I785qq</v-chip>{{ $t('Pressure Line Leak Tank Number') }}</div>
                <div><v-chip>iC01pp</v-chip><v-chip>IC01pp</v-chip>{{ $t('Basic Inventory Reconciliation Daily "Row" Report') }}</div>
                <div><v-chip>iC07pp</v-chip><v-chip>IC07pp</v-chip>{{ $t('Basic Inventory Reconciliation Periodic "Row" Report') }}</div>
                <div><v-chip>-</v-chip><v-chip>IC30xx</v-chip>{{ $t('Basic Reconciliation Hourly Report') }}</div>
              </v-card-text>
              <v-divider/>
              <v-card-actions>
                <v-flex
                  xs12
                  md12
                  text-xs-right>
                  <v-btn
                    color="secondary"
                    flat
                    @click="showGVRDialog(false)">
                    {{ $t('Close') }}
                  </v-btn>
                </v-flex>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-layout>
        <v-layout
          wrap>
          <v-flex
            xs12
            md12
            lg12
            text-xs-right>
            <v-btn
              :disabled="!isValidationOk"
              small
              class="mx-0 font-weight-light"
              color="dover-blue"
              @click="onSave()">
              {{ $t('Save') }}
            </v-btn>
          </v-flex>
        </v-layout>
      </v-container>
    </v-form>
  </material-card>
</template>

<script>
import Vue from 'vue'
import { i18n } from '@/i18n'

export default {
  props: {
    title: {
      type: String,
      required: true
    }
  },
  data: () => ({
    isValidationOk: false,
    tickId: 0,
    serialPortValidation: [ v => true ],
    tcpIpPortValidation: [ v => true ],
    rules: {
      required: [ v => Vue.prototype.Maglink.RulesRequired(v) ],
      port: [ v => Vue.prototype.Maglink.RulesRange(v, 1, 2) ],
      portTcpIp: [ v => Vue.prototype.Maglink.RulesRange(v, 1025, 65535) ],
      serialPortInUse: [ true ],
      tcpIpPortInUse: [ true ]
    },
    headers: [
      { sortable: false, text: i18n.t('Pos') },
      { sortable: false, text: i18n.t('Connection') },
      { sortable: false, text: i18n.t('Sales') },
      { sortable: false, text: i18n.t('Protocol') },
      { sortable: false, text: '' },
      { sortable: false, text: i18n.t('Units') },
      { sortable: false, text: i18n.t('Port') },
      { sortable: false, text: i18n.t('Baud rate') },
      { sortable: false, text: i18n.t('Parity') },
      { sortable: false, text: i18n.t('Data bit') },
      { sortable: false, text: i18n.t('Stop bit') }
    ],
    mainSettings: {
      comm1: 0,
      comm2: 0,
      tcpIpPort: 0,
      printer: 0,
      defaultLeakThreshold: 1,
      gilbarcoInvalidDataFill: 0,
      enableGilbarcoSetCommands: false,
      posProtocols: []
    },
    unitList: [],
    baudRateList: [],
    parityList: [],
    dataBitList: [],
    stopBitList: [],
    levelUnitList: [],
    volumeUnitList: [],
    // tempUnitList: [],
    // densityUnitList: [],
    protocols: [],
    printers: [],
    commPort1Available: false,
    commPort2Available: false,
    GVRdialog: false
  }),
  computed: {
    gilbarcoInvalidField: {
      get: function () {
        if (this.mainSettings.gilbarcoInvalidDataFill !== '0'.charCodeAt(0)) {
          return 0
        }
        return 1
      },
      set: function (value) {
        this.mainSettings.gilbarcoInvalidDataFill = 0
        if (value > 0) {
          this.mainSettings.gilbarcoInvalidDataFill = '0'.charCodeAt(0)
        }
      }
    }
  },
  mounted () {
    // this.rules.required = [ v => (!!v || v === 0) || this.$t('Required') ]

    this.serialPortValidation = this.rules.required.concat(this.rules.port)
    this.tcpIpPortValidation = this.rules.required.concat(this.rules.portTcpIp)

    this.unitList.push({ code: 4, desc: this.$t('Metric mm') })
    this.unitList.push({ code: 1, desc: this.$t('Metric cm') })
    this.unitList.push({ code: 2, desc: this.$t('US') })
    // this.unitList.push({ code: 3, desc: this.$t('Imperial') })

    this.baudRateList.push({ code: 9600, desc: '9600' })
    this.baudRateList.push({ code: 4800, desc: '4800' })
    this.baudRateList.push({ code: 2400, desc: '2400' })
    this.baudRateList.push({ code: 1200, desc: '1200' })
    this.parityList.push({ code: 'N', desc: this.$t('None') })
    this.parityList.push({ code: 'E', desc: this.$t('Even') })
    this.parityList.push({ code: 'O', desc: this.$t('Odd') })
    this.dataBitList.push({ code: 8, desc: '8' })
    this.dataBitList.push({ code: 7, desc: '7' })
    this.stopBitList.push({ code: 1, desc: '1' })
    this.stopBitList.push({ code: 2, desc: '2' })

    this.Maglink.GetOptions()
      .then(response => {
        this.protocols = response.data.protocols // .filter(item => item.code !== 7).map(item => item) // filter torex protocol
        this.levelUnitList = response.data.levelUnits
        this.volumeUnitList = response.data.volumeUnits
        this.printers = response.data.printers

        // need enable property to manage GUI
        if (this.printers.length < 4) {
          this.printers.push({ code: 3, desc: 'Usb', enable: false })
        }
        for (let index = 0; index < this.printers.length; index++) {
          this.printers[index].enable = false
        }

        // sort by desc
        this.protocols.sort((a, b) => (a.desc > b.desc) ? 1 : -1)

        this.Maglink.GetSettings('SystemProtocols')
          .then(response => {
            this.mainSettings = { ...this.mainSettings, ...response.data }

            this.checkCommPortAvailability()
          }
          )
          .catch(error => (this.snack('error', error.message)))
      })
      .catch(error => (this.snack('error', error.message)))
  },
  methods: {
    timerStart () {
      // timer already active
      if (this.tickId > 0) return

      this.tickId = setInterval(this.timerTick, 500)
    },
    timerStop () {
      if (this.tickId === 0) return

      clearInterval(this.tickId)
      this.tickId = 0
    },
    timerTick () {
      this.$refs.form.validate()
      this.timerStop()
    },
    isSerialPos (itemType) {
      return (itemType === 0)
    },
    isTcpIpPos (itemType) {
      return (itemType === 1)
    },
    isNonePos (itemType) {
      return (itemType === 2)
    },
    isFirstPos (item) {
      return (item.pos === 1)
    },
    isGilbarcoPos (itemType) {
      return (itemType === 1)
    },
    buildConnectionString (item) {
      return item.baudRate.toString() + ',' + item.parity + ',' + item.dataBit.toString() + ',' + item.stopBit.toString()
    },
    checkCommPortAvailability () {
      let list = this.mainSettings.posProtocols
      let comm1Counter = 0
      let comm2Counter = 0
      for (let index = 0; index < list.length; index++) {
        comm1Counter += (list[index].port === 1) ? 1 : 0
        comm2Counter += (list[index].port === 2) ? 1 : 0
      }
      this.commPort1Available = (comm1Counter === 0)
      this.commPort2Available = (comm2Counter === 0)
    },
    onTypeChange (item) {
      item.port = item.port * 1 // must convert to number

      if (this.isNonePos(item.type)) {
        item.port = 0
        item.configuration = ''
        item.protocol = 0
        item.unitSet = 4
      } else if (this.isSerialPos(item.type)) {
        if (item.configuration === '') {
          item.baudRate = 9600
          item.parity = 'N'
          item.dataBit = 8
          item.stopBit = 1
        }

        this.onCommPortChange(item)
      } else if (this.isTcpIpPos(item.type)) {
        this.onTcpIpPortChange(item)
      }
      // validate ports
      this.checkCommPortAvailability()
    },
    onCommPortChange (currItem) {
      for (let index = 0; index <= 2; index++) {
        let item = this.mainSettings.posProtocols[index]
        // skip the one we need to check
        if (item.pos === currItem.pos) continue
        // skip NON serial port
        if (!this.isSerialPos(item.type)) continue

        currItem.port = currItem.port * 1 // must convert to number
        item.port = item.port * 1 // must convert to number

        if (currItem.port === item.port) {
          this.serialPortValidation = [ this.$t('Serial port "{0}" already in use', [ item.port ]) ]
          this.timerStart()
          // this.$refs.form.validate()
          // this.isValidationOk = false
          this.checkCommPortAvailability()

          return
        }
      }

      this.checkCommPortAvailability()

      this.serialPortValidation = this.rules.required.concat(this.rules.port)
      this.timerStart()
      // this.$refs.form.validate()
      // this.isValidationOk = true
    },
    onTcpIpPortChange (currItem) {
      for (let index = 0; index <= 2; index++) {
        let item = this.mainSettings.posProtocols[index]
        // skip the one we need to check
        if (item.pos === currItem.pos) continue
        // skip serial port
        if (this.isSerialPos(item.type)) continue

        currItem.port = currItem.port * 1 // must convert to number
        item.port = item.port * 1 // must convert to number

        if (currItem.port === item.port) {
          this.tcpIpPortValidation = [ this.$t('TCP-IP port "{0}" already in use', [ item.port ]) ]
          this.timerStart()
          // this.$refs.form.validate()
          // this.isValidationOk = false
          this.checkCommPortAvailability()

          return
        }
      }

      this.checkCommPortAvailability()

      this.tcpIpPortValidation = this.rules.required.concat(this.rules.portTcpIp)
      this.timerStart()
      // this.$refs.form.validate()
      // this.isValidationOk = true
    },
    onSalesChange (selItem) {
      for (let index = 0; index <= 2; index++) {
        let item = this.mainSettings.posProtocols[index]
        item.acr = (item.pos === selItem.pos) ? 1 : 0
      }
    },
    showGVRDialog (value) {
      this.GVRdialog = value
    },
    onSave () {
      if (!this.$refs.form.validate()) {
        this.isValidationOk = false
        return
      }

      this.isValidationOk = true
      this.mainSettings.comm1 = 0
      this.mainSettings.comm2 = 0
      this.mainSettings.tcpIpPort = 0

      for (let index = 0; index <= 2; index++) {
        let item = this.mainSettings.posProtocols[index]

        item.port = item.port * 1 // must convert to number

        // only for serial ports
        if (item.port === 1 || item.port === 2) {
          item.configuration = this.buildConnectionString(item)

          if (item.port === 1) {
            this.mainSettings.comm1 = 1
          } else {
            this.mainSettings.comm2 = 2
          }
        } else {
          this.mainSettings.tcpIpPort = item.port
        }

        if (item.acr === undefined) item.acr = 0
        item.acr = item.acr ? 1 : 0
      }

      this.Maglink.SetSettings('SystemProtocols', this.mainSettings)
        .then(response => (this.snack('success', response.data['done'])))
        .catch(error => { this.snack('error', error.message) })

      this.$emit('settingsSaved')
    },
    snack (color, message) {
      message = this.title + ': ' + message
      this.$store.dispatch('showSnackbar', { color, message, show: true })
    }
  }
}
</script>
